module.exports = __webpack_public_path__ + "img/project_6.f4e622d2.png";